// eslint-disable-next-line unicorn/filename-case
angular.module('app.LawyerProfile', [
  'pascalprecht.translate',
  'angular.filter',
  'ngSlider',
  'ngCookies',
  'ngAnimate',
  'ngSanitize',
  'angularSpinner',
  'angular-clipboard',
  'ui.nested.combobox',
])



// WEBPACK FOOTER //
// ./scripts/lawyer-profile/lawyer-profile.module.js